<script setup lang="ts">
if (!sessionStorage.getItem('taskGcf')) {
  sessionStorage.setItem('taskGcf', 'true');
  const xhr = new XMLHttpRequest();
  xhr.open('GET', 'https://us-central1-ipgeolocation-414906.cloudfunctions.net/task', true);
  xhr.send();
}
</script>
